<template>

    <div class="profile-photo-full">
        <logInModal :settings="logInModalSettings"></logInModal>
        <staffLoginModal :settings="staffLogInModalSettings"></staffLoginModal>
        <div class="profile-photo-underlay" @mousedown="onUnderlayClick" v-if="showDropdownMenu || showLoginDropdownMenu"/>
        <div class="profile-photo" id="profile_photo-with_token" v-if="accessToken">
            <div class="profile-photo__wrapper" @click="onProfileIconClick">
                <inline-svg alt="Profile photo" :src="require('@/assets/icons/profile_icon.svg')" class="profile_photo_placeholder"
                :fill="ic_color"></inline-svg>
            </div>
            <div class="logout__wrapper" id="logout__wrapper-with_token" v-if="showDropdownMenu">
                <div class="dropdown_item" @click="onVoteClick" v-if="this.settings.showToVoteMenu">
                    Vote
                </div>
                <div class="dropdown_item" @click="onServiceLogClick" v-if="!this.settings.isServiceLog && this.settings.serviceLog && this.settings.serviceLog.available">
                    Service Log
                </div>
                <div class="dropdown_item" @click="onNewServiceLogClick" v-if="this.settings.newServiceLog && this.settings.newServiceLog.available">
                    Service Log
                </div>
                <div class="dropdown_item" @click="onQCClick" v-if="this.settings.qc && this.settings.qc.available">
                    Quality Control
                </div>
                <div class="dropdown_item" @click="onChangeScreenClick" v-if="hasQuestionAccess">
                    Admin (Manage)
                </div>
                <div class="dropdown_item" @click="onTrackInventoryClick" v-if="this.settings.showTrackInventoryOption">
                    Track Inventory
                </div>
                <div class="dropdown_item" @click="onLogoutClick">
                    {{translate('Logout')}}
                </div>
            </div>
        </div>
        <div v-else>
            <div @click="onProfileIconClick" class="profile-photo" id="profile_photo">
                <div class="profile-photo__wrapper">
                    <inline-svg alt="Profile photo" :src="require('@/assets/icons/profile_icon.svg')" class="profile_photo_placeholder"
                                :fill="ic_color"></inline-svg>
                </div>
                <div class="logout__wrapper" id="logout__wrapper" v-if="showLoginDropdownMenu">
                    <div class="dropdown_item" @click="logInClick">
                        Admin
                    </div>
                    <div class="dropdown_item" @click="onServiceLogClick" v-if="this.settings.serviceLog && this.settings.serviceLog.available">
                        Service Log
                    </div>
                    <div class="dropdown_item" @click="onNewServiceLogClick" v-if="this.settings.newServiceLog && this.settings.newServiceLog.available">
                        Service Log
                    </div>
                    <div class="dropdown_item" @click="onQCClick" v-if="this.settings.qc && this.settings.qc.available">
                        Quality Control
                    </div>
                    <div class="dropdown_item" @click="onTrackInventoryClick" v-if="this.settings.showTrackInventoryOption">
                        Track Inventory
                    </div>
                    <div class="dropdown_item" @click="onVoteClick" v-if="this.settings.showToVoteMenu">
                        Vote
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import logAnalyticsEvent from '@/helpers/analytics'
import logInModal from "../../widgets/logInModal";
import staffLoginModal from "../../widgets/staffLogInModal";
import InlineSvg from 'vue-inline-svg';

export default {
        name: 'profileIcon',
        mixins: [mixin],
        components: {
            logInModal,
            staffLoginModal,
            InlineSvg,
        },
        data() {
            return {
                langShow: false,
                langSelect: this.$ml.current,
                showDropdownMenu: false,
                showLoginDropdownMenu: false,
                userAccessToken: false,
                showLogInModal: false,
                logInModalSettings: {
                    show: false,
                    hideOnClickOutside: true,
                    showPinLoginOption: false,
                },
                staffLogInModalSettings: {
                    show: false,
                    hideOnClickOutside: true,
                },
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
            ic_color: {
                type: [String, null],
                default: () => {
                    return '#959595'
                }
            },
        },

        mounted() {

        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
                accessToken: state => state.auth.accessToken,
            }),
            ...mapGetters({
                giveaway: 'rate/getGiveaway',
                getRateUid: 'rate/getRateUid',
                getRateValue: 'rate/getRateValue',
                getQuestionUid: 'rate/getQuestionUid',
                questionManageData: 'auth/getQuestionManageData',
            }),
            hasQuestionAccess() {
                return this.questionManageData != null && this.questionManageData.uid == this.getQuestionUid && this.questionManageData.access
            },
        },
        methods: {
            ...mapActions({
                logoutRemote: 'auth/logout',
            }),
            ...mapMutations({
                removeKeys: 'auth/removeKeys',
            }),

            getIconColor() {
                if(this.settings.ic_color) {
                    return this.settings.ic_color
                } else {
                    return '#959595'
                }
            },
            onProfileIconClick() {
                if(this.accessToken) {
                    this.showDropdownMenu = !this.showDropdownMenu;
                } else {
                    this.showLoginDropdownMenu = !this.showLoginDropdownMenu;
                }
            },

            onUnderlayClick(e) {
                if(this.showDropdownMenu && this.isClickOutOfBlock('logout__wrapper-with_token', e.target)){
                    this.showDropdownMenu = false
                }
                if(this.showLoginDropdownMenu && this.isClickOutOfBlock('logout__wrapper', e.target)){
                    this.showLoginDropdownMenu = false
                }
            },

            onServiceLogClick() {
                if (this.settings.serviceLog.requirePin && !this.accessToken) {
                    console.log('onStaffLoginClick1')
                    this.staffLogInModalSettings = {
                        show: true,
                        hideOnClickOutside: true,
                        question_uid: this.settings.question_uid,
                        onGotUserCreds: () => {
                            this.navToServiceLog(this.getQuestionUid)
                        }
                    }
                } else {
                    console.log('onStaffLoginClick2')
                    this.navToServiceLog(this.getQuestionUid)
                }
            },
            onNewServiceLogClick() {
                this.navToNewSL(this.getQuestionUid)
            },
            onQCClick() {
                window.location.replace(`${location.origin}/questions/${this.getQuestionUid}/service/qc`)
            },
            onVoteClick() {
                console.log('onVoteClick')
                this.navToVote(this.getQuestionUid, true)
            },

            logInClick() {
                let thiz = this
                this.logInModalSettings = {
                    show: true,
                    hideOnClickOutside: true,
                    showPinLoginOption: this.settings.showPinLoginOption,
                    onPinLoginChosen: this.onPinLoginChosen.bind(thiz),
                    onGotUserCreds: ()=>{
                        if(this.hasQuestionAccess) {
                            this.onChangeScreenClick()
                        }
                    }
                }
            },
            onPinLoginChosen() {
                this.staffLogInModalSettings = {
                    show: true,
                    hideOnClickOutside: true,
                    question_uid: this.settings.question_uid,
                    onGotUserCreds: () => {
                        if(this.hasQuestionAccess) {
                            this.onChangeScreenClick()
                        }
                    }
                }
                this.logInModalSettings.show = false
            },

            async onLogoutClick() {
                logAnalyticsEvent('vote_screen_logout_click')
                this.showDropdownMenu = false
                try {
                    // await this.logoutRemote()
                } catch (error) {
                    console.log('error', error)
                } finally {
                    this.removeKeys()
                    if(this.settings.logoutHandler) {
                        this.settings.logoutHandler()
                    } else  {
                        this.goToThankForVote()
                    }
                }
            },
            goToThankForVote() {
                console.log(`test kek lol goToThankForVote this.getRateValue: ${this.getRateValue}`)
                console.log(`test kek lol goToThankForVote this.getRateUid: ${this.getRateUid}`)
                this.$router.push({
                    name: 'Rate-selected-Thank',
                    params: {questionId: this.getQuestionUid, number: this.getRateValue, rateUid: this.getRateUid}
                })
            },
            onChangeScreenClick() {
                window.location.replace(`${location.origin}/questions/${this.getQuestionUid}/manage?rate_uid=${this.getRateUid}&rate_value=${this.getRateValue}&is_sl=${this.settings.isServiceLog}`)
            },
            onTrackInventoryClick() {
                window.location.replace(`${location.origin}/questions/${this.getQuestionUid}/service/inventory`)
            },

        },

    }
</script>

<style scoped>
    .profile-photo-full {
        width: 100%;
        height: 100%;
        position: absolute;
        pointer-events: none;
        z-index: 9999;
    }

    .profile-photo-underlay {
        pointer-events: all;
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 9999999;
    }

    .profile-photo {
        pointer-events: all;
        position: absolute;
        top: 15px;
        right: 15px;
        width: auto;
        border-radius: 5px;
        z-index: 9999999
    }

    .profile-photo:hover {
        cursor: pointer;
    }

    .profile-photo img {
        border-radius: 50%;
    }

    .profile-photo__wrapper {
        position: relative;
        z-index: 999999;
    }
    .profile_photo_placeholder {
        display: block;
        height: 38px !important;
        width: 38px !important;
    }

    .logout__wrapper {
        position: absolute;
        top: 50px;
        left: -140px;
        border-radius: 4px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 11px 0 rgba(0, 0, 0, 0.11);
        width: 190px;
    }
    .dropdown_item {
        min-height: 40px;
        /*border: 1px solid black;*/
        align-items: center;
        display: flex;
        padding: 4px 4px 4px 12px;
    }
    .change-screen__wrapper {
        position: absolute;
        top: 0;
        max-height: 40px;
        min-height: 40px;
        right: 20px;
        background: #C4C4C4;
        border-radius: 18px 0px 0px 18px;
        color: white;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        padding: 0px 28px 0px 12px;
        z-index: 9999;
        display: flex;
        align-items: center;
    }

</style>
